import React, { ReactElement } from 'react';
import { Grid } from '@mui/material';

interface EmptyDataInterface {
  dataType?: string;
  action?: ReactElement;
  messageOverride?: ReactElement | string;
}

const EmptyData = ({ dataType, messageOverride, action }: EmptyDataInterface) => {
  const message = messageOverride ?? `No ${dataType ?? 'data'} has been created yet`;

  return (
    <Grid container textAlign='center'>
      <Grid item xs={12}>
        {message}
      </Grid>
      <Grid item xs={12}>
        {action}
      </Grid>
    </Grid>
  );
};

export default EmptyData;
